import { actionTypes } from '@buffer-mono/async-data-fetch'

// @ts-expect-error TS(7006) FIXME: Parameter 'next' implicitly has an 'any' type.
export default () => (next) => (action) => {
  next(action)
  if (
    action.type.endsWith(actionTypes.FETCH_FAIL) &&
    action.error.includes(
      'Buffer is under maintenance, please, try again soon',
    ) &&
    action.error.includes('503')
  ) {
    // TO DO: update use of location change in Redux
    // https://linear.app/buffer/issue/CHAN-5410/redux-navigation-audit-document-use-of-push-in-middleware-and-location
    window.location.replace('/maintenance')
  }
}
